import { useQuery } from '@tanstack/react-query';
import { useLocation, useParams } from 'react-router';

import { postSuggestions } from 'queries/common/postSuggestions';
import { RootStore } from 'store';
import { scanDomForActions, getActionFromPath } from '../scanDomForActions';

export type UseSuggestionsOptions = {
  sessionId: string | null;
  conversationLength: number;
  enabled?: boolean;
};

export function useSuggestions({ sessionId, conversationLength, enabled = true }: UseSuggestionsOptions) {
  const { customerProfile } = RootStore;
  const location = useLocation();
  const params = useParams<{ tab?: string }>();

  const customerIdStr = customerProfile?.ID ? String(customerProfile.ID) : null;

  const { data, isFetching } = useQuery(
    ['suggestions', customerIdStr, sessionId, location.pathname, params.tab, conversationLength],
    async () => {
      const availableActions = scanDomForActions();
      const currentAction = getActionFromPath(location.pathname);

      return await postSuggestions({
        customerId: customerIdStr,
        sessionId: sessionId,
        pageContext: {
          urlPath: location.pathname,
          activeTab: params.tab || null,
          action: currentAction,
          availableActions: availableActions.length > 0 ? availableActions : null,
        },
      });
    },
    {
      keepPreviousData: true,
      staleTime: 5000,
      enabled,
    }
  );

  return {
    suggestions: data?.suggestions || [],
    suggestionsLogId: data?.logId || null,
    isLoading: isFetching,
  };
}
